import React, { useEffect, useState } from "react"
import { createPortal } from "react-dom"
import css from "@css/modules/HottestDeals.module.scss"
import Image from "next/image"
import logo2x from "@public/images/logo@2x.png"
import { openModal } from "@components/Layout/components/LoginModal"
import { useUser } from "@lib/api/user"
import { Spin } from "antd"

export function AuthDialog() {
    const [elem, setElem] = useState<HTMLDivElement>(null)
    const { isLoading } = useUser()

    useEffect(() => {
        const elem = document.createElement("div")
        setElem(elem)
        document.getElementById("dialog-portal")?.appendChild(elem)
        document.body.style.overflow = "hidden"
        return () => {
            document.body.style.overflow = ""
            document.getElementById("dialog-portal")?.removeChild(elem)
        }
    }, [])
    const toSignUp = () => {
        openModal(location.pathname, true)
    }
    const toSignIn = () => {
        openModal(location.pathname, false)
    }
    return (
        elem &&
        createPortal(
            <div className={css.authDialog}>
                <div className={css.backdrop} />
                <div className={css.container}>
                    <div className={css.content}>
                        <Image src={logo2x} alt="DVC logo" width={70} height={49} className={css.logo} />
                        {isLoading ? (
                            <>
                                <h1>Checking session...</h1>
                                <div className={css.spinContent}>
                                    <Spin size="large" />
                                </div>
                            </>
                        ) : (
                            <>
                                <h1>Sign Up Today</h1>
                                <ul className={css.list}>
                                    <li>Saved searches</li>
                                    <li>Unlimited email notifications</li>
                                    <li>Set & Manage favorites</li>
                                    <li>Access to exclusive content</li>
                                    <li>Access “Rare Deals” notifications</li>
                                </ul>
                                <button className={css.toSignUpBtn} onClick={toSignUp}>
                                    Sign Up For Free
                                </button>
                                <button className={css.naveAccount} onClick={toSignIn}>
                                    Have an account? <b>Sign In</b>
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </div>,
            elem
        )
    )
}
